import { useState } from 'react';
import { Field } from 'formik';
import { TabsUI, FormLabelUI, FormErrorUI, InputUI, FileTabUI, DeleteDialogUI } from '../Interface';
import DynamicPropertyMain from '../DynamicProperty/DynamicPropertyMain';
import crmTaskService from '../../service/crmTask.service';
import addNotification from '../../utils/addNotification';
import { NotificationType } from '../../config';
import NextEvent from './NextEvent';

const DescriptionPanel = (props) => {
  return (
    <div>
      <div className="col-span-full relative">
        <div className="mt-2">
          <Field
            type="text"
            name="description"
            as={InputUI}
            className={`${props.disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
            fullWidth
            label={<FormLabelUI text="Megjegyzés" />}
            variant="standard"
            helperText={<FormErrorUI message={props.errors.description} />}
            disabled={props.disabled}
            InputLabelProps={{ shrink: props.values.description !== '' }}
            multiline
            rows={4}
          />
        </div>
      </div>
    </div>
  );
};

const CrmTaskTabs = (props) => {
  const { user, selectedValues, setSelectedValues, disabled, setRefetchTable } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [removeElement, setRemoveElement] = useState(null);
  const [deleteDialog, setDeletDialog] = useState(false);

  const handleUpload = (files) => {
    if (!selectedValues.id) {
      return addNotification({
        content: 'Nincs kiválasztott elem!',
        type: NotificationType.ERROR,
      });
    }

    const uploadPromises = files.map((file) =>
      crmTaskService.uploadFile(file, selectedValues.id, user.userId).then((data) => {
        setSelectedValues((prev) => ({ ...prev, crmTaskAttachment: data }));
      })
    );

    Promise.all(uploadPromises)
      .then(() => {
        setRefetchTable(true);
      })
      .catch((error) => {
        console.error('Fájl feltöltési hiba:', error);
      });
  };

  const handleDelete = (data) => {
    setRemoveElement(data.id);
    setDeletDialog(true);
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
    setRefetchTable(null);
  };
  const handleRemoveElement = (data) => {
    crmTaskService.deleteFile(removeElement, props.user.userId).then((data) => {
      setSelectedValues((prev) => ({ ...prev, crmTaskAttachment: data }));
      hideDeleteDialog();
    });
  };

  const tabs = [
    {
      id: 0,
      name: 'Tulajdonságok',
      content: <DynamicPropertyMain {...props} />,
    },
    {
      id: 1,
      name: 'Megjegyzés',
      content: <DescriptionPanel {...props} />,
    },
    {
      id: 2,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          disabled={disabled || !selectedValues.id}
          savedFiles={props.selectedValues.crmTaskAttachment ?? []}
          handleUpload={handleUpload}
          handleDelete={handleDelete}
        />
      ),
    },
    {
      id: 3,
      name: 'Következő esemény',
      content: <NextEvent {...props} />,
    },
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI handleRemoveElement={handleRemoveElement} show={deleteDialog} onHide={() => hideDeleteDialog()} />
    </div>
  );
};

export default CrmTaskTabs;
